import { HeaderContent, HEADER_TITLE_CLASS } from '../../../components/shell/app-header';
import { Link, useParams } from '../../../lib/routing';
import { DOMAINES } from './accueil-config';
import { A_VENIR_PAR_DOMAINE, parcoursDuDomaine, trouverDomaine } from './parcours-config';

const CLASSE_ENTREE = 'min-h-[44px] rounded-sm border border-border bg-card px-4 py-3 flex items-center gap-3';
const CLASSE_TITRE = 'flex-1 font-semibold text-[color:var(--naia-text-primary)]';
const CLASSE_ETIQUETTE = 'text-[13px] text-[color:var(--naia-text-secondary)]';

export default function DomainePage() {
  const { domaine } = useParams<{ domaine?: string }>();
  const id = trouverDomaine(domaine);
  const titre = DOMAINES.find((d) => d.id === id)?.titre;

  if (!id || !titre) {
    return (
      <>
        <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
          <h1 className={HEADER_TITLE_CLASS}>Domaine introuvable</h1>
        </HeaderContent>
        <p className="m-0 p-4 text-[color:var(--naia-text-secondary)]">Ce domaine n’existe pas ou arrive bientôt.</p>
      </>
    );
  }

  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
        <h1 className={HEADER_TITLE_CLASS}>{titre}</h1>
      </HeaderContent>
      <ul
        className="m-0 list-none p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] flex flex-col gap-3"
        aria-label="Parcours"
      >
        {parcoursDuDomaine(id).map((p) => (
          <li key={p.slug}>
            <Link to={`/mini-apps/francais-college/parcours/${p.slug}`} className={`${CLASSE_ENTREE} no-underline`}>
              <span className={CLASSE_TITRE}>{p.titre}</span>
              <span className={CLASSE_ETIQUETTE}>{p.statut === 'beta' ? 'Bêta' : 'Brouillon, pas encore testé'}</span>
            </Link>
          </li>
        ))}
        {(A_VENIR_PAR_DOMAINE[id] ?? []).map((libelle) => (
          <li key={libelle}>
            <div className={CLASSE_ENTREE}>
              <span className={CLASSE_TITRE}>{libelle}</span>
              <span className={CLASSE_ETIQUETTE}>À venir</span>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
